export default function(http) {
  return {
    queryByPage(data){
      return http.json({
        url: `/article/query`,
        data
      });
    },
      list(data){
          return http.json({
              url: `/article/list`,
              data
          });
      },
      /**
       * 获取详情
       * @param data
       * @return {*}
       */
      getInfo(data) {
          return http.json({
              url: `/article/get?id=${data.id}`
          })
      },

      saveInfo(data){
          return http.json({
              url: `/article/save`,
              data
          });
      },
      /**
       * 删除
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.get(
              `/article/delete?id=${data.id}`
          )
      },
      /**
       * 隐藏或显示帖子
       * @param data
       * @return {*}
       */
      showOrHidden(data) {
          return http.get(
             `/article/showOrHidden?id=${data.id}&state=${data.state}`
          )
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/article.js